import { useIntl } from 'react-intl-next';

import type { SelectionExtension } from '@atlaskit/editor-plugin-selection-extension';
import PlusSquareIcon from '@atlaskit/icon/core/plus-square';
import type { ViewMode } from '@atlaskit/editor-plugin-editor-viewmode';

import {
	useIssueCreateSidePanelContext,
	useSetIsCreatedWithAi,
} from '@confluence/issue-create-side-panel';
import { useContentType, usePageContentId } from '@confluence/page-context';
import { useRightSidebarContext } from '@confluence/page-layout-context';

import { messages } from '../messages';
import { getPageMode } from '../utils/pageModeUtils';
import { jiraWorkItemCreateActions } from '../jiraWorkCreateActions';

export type UseJiraWorkCreateSelectionExtensionProps = {
	viewMode: ViewMode | undefined;
	isLivePage: boolean | undefined;
	hasEditPermission: boolean | undefined;
};

export const useJiraWorkCreateSelectionExtension = ({
	viewMode,
	isLivePage,
	hasEditPermission,
}: UseJiraWorkCreateSelectionExtensionProps): SelectionExtension => {
	const { formatMessage } = useIntl();
	const [contentId] = usePageContentId();
	const [contentType] = useContentType();
	const rightSidebarContext = useRightSidebarContext();
	const [, actions] = useIssueCreateSidePanelContext();
	const setIsCreatedWithAi = useSetIsCreatedWithAi();
	const pageMode = getPageMode(viewMode, isLivePage, hasEditPermission);

	return {
		name: formatMessage(messages.singleCreateWorkItemName),
		icon: PlusSquareIcon,
		onClick: () => {
			const activeSelection = window.getSelection();
			const container = document.querySelector('div#ak-editor-textarea');
			jiraWorkItemCreateActions({
				activeSelection,
				container,
				contentId,
				contentType,
				rightSidebarContext,
				actions,
				setIsCreatedWithAi,
				pageMode,
			});
		},
	};
};
